/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientContactWithDetails } from './ClientContactWithDetails';
import {
	ClientContactWithDetailsFromJSON,
	ClientContactWithDetailsFromJSONTyped,
	ClientContactWithDetailsToJSON,
} from './ClientContactWithDetails';

/**
 * Payload of enumerated client contacts for a client organization
 * @export
 * @interface ClientContactWithDetailsEnumeration
 */
export interface ClientContactWithDetailsEnumeration {
	/**
	 *
	 * @type {Array<ClientContactWithDetails>}
	 * @memberof ClientContactWithDetailsEnumeration
	 */
	items: Array<ClientContactWithDetails>;
}

/**
 * Check if a given object implements the ClientContactWithDetailsEnumeration interface.
 */
export function instanceOfClientContactWithDetailsEnumeration(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'items' in value;

	return isInstance;
}

export function ClientContactWithDetailsEnumerationFromJSON(
	json: any
): ClientContactWithDetailsEnumeration {
	return ClientContactWithDetailsEnumerationFromJSONTyped(json, false);
}

export function ClientContactWithDetailsEnumerationFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ClientContactWithDetailsEnumeration {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		items: (json['items'] as Array<any>).map(ClientContactWithDetailsFromJSON),
	};
}

export function ClientContactWithDetailsEnumerationToJSON(
	value?: ClientContactWithDetailsEnumeration | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		items: (value.items as Array<any>).map(ClientContactWithDetailsToJSON),
	};
}
